class Templating {
	static baseColor = getComputedStyle(document.documentElement).getPropertyValue('--colorBrand');
}